import Link from 'next/link';
import styles from './footer.module.scss';
import LogoSvg from '../../../ui/icons/logoSVG';
import { ButtonBlindFooter } from './button-blind-footer/button-blind-footer';

export const Footer = () => {
  const actualData = new Date().getFullYear();
  const MEDIA_KIT_URL =
    'https://tvzvezda.ru/storage/documents/2026/10/21/0e206019a21348279f9166df0719ba8e.pdf';

  return (
    <footer className={styles.footer}>
      <div className={styles.wrapper}>
        <article className={styles.list}>
          <Link className={styles.link} href={'/goroda'}>
            Города вещания
          </Link>
          <a
            className={styles.link}
            href={MEDIA_KIT_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Медиа-кит
          </a>
          <Link className={styles.link} href={'/contacts'}>
            Контакты
          </Link>
          {/*<Link className={styles.link} href={'#'}>*/}
          {/*  Напишите нам*/}
          {/*</Link>*/}
          {/*<Link className={styles.link} href={'#'}>*/}
          {/*  Озвучиваем*/}
          {/*</Link>*/}
        </article>
        <article className={styles.logoRow}>
          <LogoSvg className={styles.logoSVG} />
          <ButtonBlindFooter />
        </article>
        <article className={styles.copyright}>
          <p className={styles.text}>
            {`
            © 2006-${actualData} АО «ТРК ВС РФ`}{' '}
            <Link className={styles.link} href={'https://tvzvezda.ru/'}>
              «ЗВЕЗДА»
            </Link>
          </p>
        </article>
      </div>
      <div id="app-version"></div>
    </footer>
  );
};
